import { render, staticRenderFns } from "./MinimalProfileModal.vue?vue&type=template&id=50da91a6&scoped=true"
import script from "./MinimalProfileModal.vue?vue&type=script&lang=ts"
export * from "./MinimalProfileModal.vue?vue&type=script&lang=ts"
import style0 from "./MinimalProfileModal.vue?vue&type=style&index=0&id=50da91a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50da91a6",
  null
  
)

export default component.exports